import React from 'react';

import { TAsyncActionViewScreen } from 'types/state';

type TAsyncState = {
  pending: boolean;
  resolved: boolean;
};

export const useAsyncActionViewScreen = (asyncState: null | TAsyncState) => {
  return React.useMemo<TAsyncActionViewScreen>(() => {
    if (asyncState) {
      if (asyncState.pending) {
        return 'PENDING';
      }
      if (asyncState.resolved) {
        return 'DONE';
      }
      return 'ACTIVE';
    }
    return 'ACTIVE';
  }, [asyncState]);
};
